import React, { Component } from "react";
import { TimelineMax, Back } from "gsap";

import jsIcon from "../../assets/img/icons/js.svg";
import mongoIcon from "../../assets/img/icons/mongodb.svg";
import mysqlIcon from "../../assets/img/icons/mysql.svg";
import nodejsIcon from "../../assets/img/icons/nodejs.svg";
import phpIcon from "../../assets/img/icons/php.svg";
import reactIcon from "../../assets/img/icons/react.svg";
import reduxIcon from "../../assets/img/icons/redux.svg";
import vueIcon from "../../assets/img/icons/vue.svg";

class DevIcons extends Component {
  componentDidMount = () => {
    this.tl = new TimelineMax({ delay: 0, ease: Back.easeOut });

    this.tl.staggerFromTo(
      ".devIcon img",
      0.4,
      { transform: "translateY(150px)" },
      { transform: "translateY(0px)", ease: Back.easeOut },
      0.1
    );
  };

  render = () => {
    let { iconList } = this.props;
    if (!iconList) iconList = [];

    return (
      <div className="techUsed">
        <div className="devIcons" ref={c => (this.devIcons = c)}>
          {iconList.indexOf("js") > -1 && (
            <div className="devIcon">
              <img src={jsIcon} className="js" alt="icon" />
            </div>
          )}
          {iconList.indexOf("react") > -1 && (
            <div className="devIcon">
              <img src={reactIcon} className="react" alt="icon" />
            </div>
          )}
          {iconList.indexOf("node") > -1 && (
            <div className="devIcon">
              <img src={nodejsIcon} className="nodejs" alt="icon" />
            </div>
          )}
          {iconList.indexOf("mongo") > -1 && (
            <div className="devIcon wide">
              <img src={mongoIcon} className="mongo" alt="icon" />
            </div>
          )}
          {iconList.indexOf("vue") > -1 && (
            <div className="devIcon">
              <img src={vueIcon} className="vue" alt="icon" />
            </div>
          )}
          {iconList.indexOf("redux") > -1 && (
            <div className="devIcon">
              <img src={reduxIcon} className="redux" alt="icon" />
            </div>
          )}
          {iconList.indexOf("mysql") > -1 && (
            <div className="devIcon">
              <img src={mysqlIcon} className="mysql" alt="icon" />
            </div>
          )}
          {iconList.indexOf("php") > -1 && (
            <div className="devIcon">
              <img src={phpIcon} className="php" alt="icon" />
            </div>
          )}
        </div>
      </div>
    );
  };
}

export default DevIcons;



// WEBPACK FOOTER //
// ./src/components/Work/DevIcons.js